import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const countriesGetRequest = simpleAction(TYPES.COUNTRIES_GET_REQUEST);

/**
 * Request countries success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const countriesGetSuccess = simpleAction(TYPES.COUNTRIES_GET_SUCCESS);

/**
 * Request countries error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const countriesGetError = simpleAction(TYPES.COUNTRIES_GET_FAIL);
